import { MandatorType } from "@bn/theming";

export const getDefaultMandatorSlug = (): MandatorType =>
  import.meta.env.VITE_APP_MANDATOR;
